import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const TIMERREDIRECTBLOCK_LEGACY_FIELD_ORDER = [
  "duration",
  "redirect_to",
  "reset_ui",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  timerRedirectBlockDescriptor: _generatedTimerRedirectBlockDescriptor,
  timerRedirectBlockBlocDefinition,
  timerRedirectBlockDashboardLayout,
  timerRedirectBlockConfig,
  timerRedirectBlockResolveConfig,
  timerRedirectBlockProperties,
} = doodBlockConfig(
  {
    name: "Timer redirect",
    componentType: "TimerRedirectBlockComponent",
    category: "system",
    description: "Timer redirect.",
    keywords: [],
    sharedFields: {},
  },

  () => ({
    duration: propertyValue({
      type: "text",
      value: "10",
      options: {
        label: "pages.blocks.timer-redirect.duration.label",
        help: "pages.blocks.timer-redirect.duration.help",
      },
    }),
    redirect_to: propertyValue({
      type: "link",
      value: "",
      options: {
        label: "pages.blocks.timer-redirect.redirect-to.label",
      },
    }),
    reset_ui: propertyValue({
      type: "checkbox",
      value: false,
      options: {
        label: "pages.blocks.timer-redirect.reset-ui.label",
        help: "pages.blocks.timer-redirect.reset-ui.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.timer-redirect.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.timer-redirect.fieldset.redirect.label",
            fields: ["duration", "redirect_to", "reset_ui"],
          },
        ],
      },
    ],
  })
);

export function timerRedirectBlockDescriptor(): IBlockDescriptor;
export function timerRedirectBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function timerRedirectBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedTimerRedirectBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedTimerRedirectBlockDescriptor,
    timerRedirectBlockProperties,
    fieldOrder,
  );
}

export {
  timerRedirectBlockBlocDefinition,
  timerRedirectBlockDashboardLayout,
  timerRedirectBlockProperties,
  timerRedirectBlockConfig,
  timerRedirectBlockResolveConfig,
};

export type TimerRedirectBlockConfig = typeof timerRedirectBlockConfig;
